import React from "react"
import { SortIcon } from "components/Table_SortColumnIcon"
import { getFormattedTime } from "utils"
import { URL_PATHS } from "constants/index"
import { generatePath } from "react-router-dom"

const formBuilderListColumns = (history, event_id) => {
  return [
    {
      text: "id",
      dataField: "id",
      sort: true,
      hidden: true,
      formatter: (cellContent, item) => <>{item?.id}</>,
    },
    {
      text: "Creation Date",
      dataField: "created_at",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => (
        <>
          <>{item?.created_at ? getFormattedTime(item?.created_at) : "-"}</>
        </>
      ),
    },
    {
      text: "Form Builder",
      dataField: "name",
      sort: true,
      sortCaret: order => <SortIcon order={order} />,
      formatter: (cellContent, item) => <>{item?.name}</>,
    },
    {
      text: "# of Responses",
      dataField: "count_replies",
      formatter: (cellContent, item) => <>{item?.count_replies}</>,
    },
    {
      text: "Details",
      dataField: "details",
      isDummyField: true,
      formatter: (cellContent, item) => (
        <span
          className="btn-link"
          style={{ cursor: "pointer" }}
          onClick={() =>
            history.push(
              generatePath(URL_PATHS.FORM_BUILDER_REPORTS, {
                event_id: event_id,
                feature_id: item?.id,
              })
            )
          }
        >
          View
        </span>
      ),
    },
  ]
}

export default formBuilderListColumns
